import { MLBTheme } from '../../style/theme.types';
import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';
import { OptionsType, GroupedOptionsType } from 'react-select';

export interface Options {
  label: string;
  value: string | number;
}

export interface OptionGroups {
  label: string;
  options: Options[];
}

export enum DropdownColorSchemes {
  LINK_BLUE = 'link-blue',
  TICKET_LINK_GREEN = 'ticket-link-green',
  MLB_TV_ORANGE = 'mlb-tv-orange',
  TEAM = 'team'
}

export interface DropdownProps extends DefaultProps {
  multiple?: boolean;
  searchable?: boolean;
  clearable?: boolean;
  disabled?: boolean;
  autoSelect?: boolean;
  width?: string;
  placeholder?: string;
  options: OptionsType<Options> | GroupedOptionsType<OptionGroups | Options>;
  theme?: MLBTheme;
  required?: boolean;
  colorScheme?: DropdownColorSchemes;
  handlers?: Handler;
  selected?: object[];
  defaultSelected?: object[];
  menuWidth?: string;
  requiredText?: string;
}
